export const FEATURES = {
    ANALYTICS: 'ANALYTICS',
    IMPORT: 'IMPORT',
    MASTER_DATA: 'MASTER_DATA',
    CONNECT_PRACTICE: 'CONNECT_PRACTICE',
    CONTROL_CENTER: 'CONTROL_CENTER',
    ENHANCED_PRODUCT_SEARCH: 'ENHANCED_PRODUCT_SEARCH',
    ENHANCED_SEARCH_UI: 'ENHANCED_SEARCH_UI',
    QUEUEING_INVOICE_ITEMS: 'QUEUEING_INVOICE_ITEMS',
    EXTERNAL_REQUESTS_LOGGING: 'SILLY_LOGGING',
};

export const GLOBAL_FEATURES = {};
